import { render, staticRenderFns } from "./ReCaptcha.vue?vue&type=template&id=92dec0ba&scoped=true&"
import script from "./ReCaptcha.vue?vue&type=script&lang=ts&"
export * from "./ReCaptcha.vue?vue&type=script&lang=ts&"
import style0 from "./ReCaptcha.vue?vue&type=style&index=0&id=92dec0ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dec0ba",
  null
  
)

export default component.exports